import { registerValidation } from "@/utils/valitation/auth";
import { registerCreate } from "@/services/auth";
import { getCookie } from "cookies-next";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";

import toast from "react-hot-toast";
import Input from "../../Input";
import Loading from "@/components/global/Loading";
import InputIcon from "../../InputIcon";
import Image from "@/components/global/Image";
import Link from "next/link";
import { preventLettersInInput } from "@/utils/global";
import { register_event } from "@/utils/gtm";

const UserSignup = ({ t, language, setIsRegister }) => {
  const [show, setShow] = useState(false);
  const [checked, setChecked] = useState(false);
  const handshake = getCookie("handshake");
  const intialValues = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    terms: "",
    phone_number: "",
  };

  const handleSubmit = async (values, setSubmitting) => {
    setSubmitting(true);
    const { phone_number, password, firstName, lastName, email } = values;

    const { data } = await registerCreate(
      handshake,
      `00966${phone_number}`,
      password,
      firstName,
      lastName,
      email
    );

    setSubmitting(false);

    if (data?.data?.success == "false") {
      // handling the error coming from backend and show to client
      toast.error(data?.data?.errormsg);
      return setSubmitting(false);
    } else {
      register_event(
        email,
        firstName + " " + lastName,
        `00966${phone_number}`,
        // is_company
        false
      );
      toast.success(data?.data?.successmsg);
      setIsRegister(false);
      return setSubmitting(false);
    }
  };
  return (
    <section>
      <p className="m-4 text-center max-sm:text-sm">
        <span className="font-bold text-secondary-800">
          {t("You can create a new account")}{" "}
        </span>
        <span className="font-semibold text-zinc-500">
          {t(
            "To enjoy the site’s benefits, such as tracking orders and registering"
          )}{" "}
          {t("products in your favorites")}
        </span>
      </p>
      <Formik
        onSubmit={(values, { setSubmitting }) => {
          handleSubmit(values, setSubmitting);
        }}
        initialValues={intialValues}
        validationSchema={registerValidation(t)}
      >
        {({ isSubmitting }) => (
          <Form
            className="grid grid-cols-2 my-2 gap-y-3 sm:gap-4"
            autoComplete="off"
          >
            <div className="col-span-full sm:col-span-1">
              <Input
                name="firstName"
                id="first-name"
                type="text"
                placeholder={t("First Name")}
                inputClassName="border max-sm:placeholder:text-sm max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
              />
            </div>
            <div className="col-span-full sm:col-span-1">
              <Input
                name="lastName"
                id="last-name"
                type="text"
                placeholder={t("Last Name")}
                inputClassName="border max-sm:placeholder:text-sm max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
              />
            </div>
            <div className="col-span-full sm:col-span-1">
              <div
                dir="ltr"
                className="flex items-center gap-1 border rounded-sm"
              >
                <Image
                  loading="eager"
                  className="mx-2 rounded-sm"
                  src="/imgs/KSA.svg"
                  height={30}
                  width={30}
                  alt="KSA Img !"
                />
                <span className="text-zinc-500 mx-1.5 max-sm:text-sm">
                  +966
                </span>
                <Field
                  name="phone_number"
                  type="tel"
                  id="phone_number"
                  onKeyDown={(event) => {
                    preventLettersInInput(event);
                  }}
                  maxLength={9}
                  className="outline-none border-none max-sm:placeholder:text-sm max-sm:text-sm p-1.5 w-full"
                />
              </div>
              <ErrorMessage
                name="phone_number"
                component="p"
                className="text-sm text-warning max-sm:text-xs"
              />
            </div>
            <div className="col-span-full sm:col-span-1">
              <Input
                name="email"
                id="email"
                type="email"
                placeholder={t("Email Address")}
                inputClassName="border max-sm:placeholder:text-sm max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
              />
            </div>

            <div className="relative col-span-full">
              <InputIcon
                name="password"
                id="password"
                placeholder={t("Password")}
                inputClassName="border max-sm:placeholder:text-sm max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                t={t}
                language={language}
                show={show}
                setShow={setShow}
              />
            </div>
            <div className="relative col-span-full">
              <InputIcon
                name="confirmPassword"
                id="confirm-password"
                placeholder={t("Confirm Password")}
                inputClassName="border max-sm:placeholder:text-sm max-sm:text-sm p-1.5 w-full rounded-sm outline-none"
                language={language}
                setShow={setShow}
                show={show}
                t={t}
              />
            </div>
            <div className="flex items-center gap-2 sm:my-2 col-span-full max-sm:text-sm">
              <div
                className={`size-4 ${
                  !checked ? "border" : "bg-secondary-900"
                } rounded-sm flex items-center justify-center`}
                onClick={() => setChecked(!checked)}
              ></div>
              <span className="cursor-pointer">
                {t("I accept to the")}{" "}
                <Link
                  href="/terms-and-conditions"
                  className="font-bold underline"
                >
                  {t("terms and conditions")}
                </Link>
              </span>
            </div>
            <button
              className="col-span-full max-sm:text-sm bg-primary text-white rounded-md font-semibold disabled:cursor-not-allowed p-1.5 w-full"
              type="submit"
            >
              {isSubmitting ? <Loading /> : t("Register")}
            </button>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default UserSignup;
